import * as React from "react";
import { forwardRef } from "react";
const SvgSeeMoreArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.00004 0.666342L5.06004 1.60634L8.78004 5.33301L0.666708 5.33301V6.66634L8.78004 6.66634L5.05337 10.3863L6.00004 11.333L11.3334 5.99967L6.00004 0.666342Z", fill: "#016CD1" }));
const ForwardRef = forwardRef(SvgSeeMoreArrow);
export default ForwardRef;
